module.exports = "https://qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5/img/register_success.png";